import React from "react";
import HeadingTag from '../../component/reusebale/heading'
import ParagraphTag from '../../component/reusebale/Paragraph'
import ResetFormSection from '../../component/reset-password/resetForm'
import db from '../../db/index.json'
import ImageTag from '../../component/reusebale/imageTag'

function ResetPassword() {
  const { login } = db;



  return (
    <div className="lg:h-screen flex items-center py-12 lg:py-0">
      <div className="flex w-[90%] mx-auto lg:h-[90vh] rounded-xl">
        <div className="w-[50%] h-full hidden lg:block">
          <ImageTag path='/assets/auth/auth-image.png' classes='w-full h-full' altText='login' />
        </div>
        <div className="lg:w-[50%] w-full h-full my-auto flex flex-col items-center justify-center bg-white">
          <div className="w-[80%] mx-auto flex flex-col items-center justify-center">
            <ImageTag path='/assets/logo.png' classes='w-full lg:w-[55%] h-32' altText='logo' />
            <div className="w-full pt-1 h-full">
              <HeadingTag title='Change password' classes='font-popinsSemiBold text-themeColor text-3xl' />
              <ParagraphTag content="You can change your password." classes='text-paraColor text-sm pt-2 font-popinsRegular' />
              <ResetFormSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
